import React, { useEffect, useState, useRef, Fragment } from "react";
import { Link, useNavigate, useLocation } from "react-router";
import constant from "../../../utils/constant";
import { findDisallowedImageSources } from "../../../utils/imageSourceHelper";
import { connect } from "react-redux";
import Loader from "../../shared/loader/loader";
import Select from "react-select";
import {
  AddIcon,
  DeleteIcon,
  EditIcon,
  CheckIcon,
  CrossIcon,
  PreviewIcon,
} from "../../../assets/icons/index";
import DeleteModal from "../../shared/common/deleteModal";
import {
  postPassage,
  updatePassage,
  getPassagesCategoryOld,
  getPassagesCategory,
  getPassagessourceType,
  getPassagesdifficultyType,
  getPassagesliteratureType,
  getPassagesDataType,
  getAssociatePassage,
  getPassagesGrammarType,
  deleteAssociateQuestion,
  getPassageById,
  postPassageTag,
  deletePassageTag,
  getClassifications,
} from "../../../api/passage.service";
import {
  Ipassage,
  IPassageInfo,
  IPassageData,
  IWidget,
} from "../../../model/interface/passage";
import { ISelectElement } from "../../../model/interface/keyValuePair";
import Breadcrumb from "../../shared/common/breadcrumb";
import { IBreadcrumb } from "../../../model/interface/breadcrumb";
import PassageEditorTabs from "./passageEditor";
import { toast } from "react-toastify";
import Tooltip from "../../shared/common/ellipsisText";
import TagSelector, { TagSelectorMode } from "../../shared/common/tagSelector";
import SelectPageSize from "../../shared/common/pageSizeDropdown";
import Pagination from "../../shared/common/pagination";
import AllowedTo from "../../shared/common/rbac";
import Permissions from "../../../utils/permissions";
import AccessDenied from "../../shared/common/accessDenied";
import {
  Dialog,
  DialogBackdrop,
  DialogTitle,
  Transition,
  TransitionChild,
} from "@headlessui/react";
import { XIcon } from "@heroicons/react/outline";
import PreviewModal from "../questions/previewModal";
import { IQuestion } from "../../../model/interface/question";
import { getContentArea } from "../../../api/contentArea.service";
import { getTextFromLearnosityPassageContent } from "../../../utils/textToSpeech/textToSpeech";
import type { Language } from "@educationgalaxy/tts-core";
import { createPassageSpeech } from "../../../api/textToSpeech.service";
import { IPassageSpeech } from "../../../model/shared/passageSpeech";
import { useNumericParam } from "../../../utils/useNumericParam";
import UgaItemIcon from "../../shared/common/ugaItemIcon";

const ManagePassage: any = (props: any) => {
  const id = useNumericParam("id");
  const editedPassageId = id ? id.toString() : "";
  const location = useLocation();
  const parameters = location.state as any;
  const [managePassage] = useState<Ipassage>(
    parameters && (parameters.editPassageId as Ipassage)
  );
  const [categoryOld, setcategoryOld] = useState<ISelectElement[]>([]);
  const [category, setCategory] = useState<ISelectElement[]>([]);
  const [sourceType, setSourceType] = useState<ISelectElement[]>([]);
  const [difficultyType, setDifficultyType] = useState<ISelectElement[]>([]);
  const [literatureType, setLiteratureType] = useState<ISelectElement[]>([]);
  const [dataType, setDataType] = useState<ISelectElement[]>([]);
  const [grade, setGrade] = useState<ISelectElement[]>([]);
  const [grammarType, setGrammarType] = useState<ISelectElement[]>([]);
  const [editedPassage, setEditedPassage] = useState<Ipassage[]>([]);
  const [englishPassageInfo, setEnglishPassageInfo] = useState<IPassageInfo>();
  const [spanishPassageInfo, setSpanishPassageInfo] = useState<IPassageInfo>();
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [associateQuestionId, setAssociateQuestionId] = useState<number>();
  const [associateEnglishQuestionId, setAssociateEnglishQuestionId] =
    useState<string>();
  const [associateSpanishQuestionId, setAssociateSpanishQuestionId] =
    useState<string>();
  const [passageId, setPassageId] = useState<number | undefined>(0);
  const [userId, setUserId] = useState<number>(0);
  const [title, setTitle] = useState<string>("");
  const [citation, setCitation] = useState<string>("");
  const [lexileLevel, setLexileLevel] = useState<string>("");
  const [notes, setNotes] = useState<string>("");
  const [notesES, setNotesES] = useState<string>("");
  const [englishPassage, setEnglishPassage] = useState<string>("");
  const [spanishPassage, setSpanishPassage] = useState<string>("");
  const [flLevel, setFlLevel] = useState<string>("");
  const [isActive, setIsActive] = useState<boolean>(true);
  const [isApproved, setIsApproved] = useState<boolean>(false);
  const [isAIAssisted, setIsAIAssisted] = useState<boolean>(false);
  const [disablePassageTTS, setDisablePassageTTS] = useState<boolean>(false);
  const [associateQuestion, setAssociateQuestion] = useState<any>([]);
  const [associateQuestionIds, setAssociateQuestionIds] = useState<string[]>(
    []
  );
  const [loading, setLoading] = useState<boolean>(false);
  const defaultValue = { label: "Select", value: "0" };
  const defaultElement = [{ label: "Select", value: "0" }];
  const [selectedGrade, setSelectedGrade] = useState(defaultValue);
  const [selectedDataType, setSelectedDataType] = useState(defaultValue);
  const [selectedSourceType, setSelectedSourceType] = useState(defaultValue);
  const [selectedGrammar, setSelectedGrammar] = useState(defaultValue);
  const [selectedLiterature, setSelectedLiterature] = useState(defaultValue);
  const [selectedDifficulty, setSelectedDifficulty] = useState(defaultValue);
  const [selectedCategory, setSelectedCategory] = useState(defaultValue);
  const [selectedCategoryOld, setSelectedCategoryOld] = useState(defaultValue);
  const [errorMessage, setErrorMessage] = useState<boolean>(false);
  const [widgetPsgDataEN, setWidgetPsgEN] = useState<IWidget>();
  const [widgetPsgDataES, setWidgetPsgES] = useState<IWidget>();
  const [app, setAuthorApp] = useState<any>();
  const [appES, setAuthorAppES] = useState<any>();
  const [passageEditor, setPassageEditor] = useState<any>();
  const [englishPsgReferenceId, setEnglishPsgReferenceId] =
    useState<string>("");
  const [spanishPsgReferenceId, setSpanishPsgReferenceId] =
    useState<string>("");
  const [combinePsgReferenceId, setCombinePsgReferenceId] =
    useState<string>("");
  const [widgetDataOnLoad, setWidgetDataOnLoad] = useState<any>();
  const [manageTags, setManageTags] = useState<boolean>(false);
  const [selectedTagIds, setSelectedTagIds] = useState<Array<number>>([]);
  const navigate = useNavigate();
  const paginationRef: any = useRef(undefined);
  const pageSizeRef: any = useRef(undefined);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const defaultPageNumber = 1;
  const defaultPageSize = 10;
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [pageNumber, setPageNumber] = useState(defaultPageNumber);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [classification, setClassification] = useState<number | undefined>(
    undefined
  );
  const [selectedClassification, setSelectedClassification] =
    useState(defaultValue);
  const [passageClassification, setPassageClassification] = useState<
    ISelectElement[]
  >([]);
  const [spanishWordCount, setSpanishWordCount] = useState<number | undefined>(
    0
  );
  const [englishWordCount, setEnglishWordCount] = useState<number | undefined>(
    0
  );
  const [islrneditorloaded, setIsLrnEditorLoaded] = useState<boolean>(false);
  const [isLrnPaginated, setIsLrnPaginated] = useState<boolean>(false);
  const [islrnspanisheditorloaded, setIsLrnSpanishEditorLoaded] =
    useState<boolean>(false);
  const [isLrnSpanishPaginated, setIsLrnSpanishPaginated] =
    useState<boolean>(false);
  const [selectedLanguage, setSelectedLanguage] = useState<string>("EN");
  const [showPassageTypeModal, setShowPassageTypeModal] = useState<boolean>(
    id ? false : true
  );
  const [selectedPassageType, setSelectedPassageType] = useState<number>(0);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [previewId, setPreviewId] = useState<string>("");
  const [questionIdPreview, setQuestionIdPreview] = useState<number>();
  const [questionIndexPreview, setQuestionIndexPreview] = useState<number>();
  const [selectedContentArea, setselectedContentArea] = useState(defaultValue);
  const [contentArea, setContentArea] = useState([]);
  const [isHumanTranslated, setIsHumanTranslated] = useState<boolean>(false);
  const [isMachineTranslated, setIsMachineTranslated] =
    useState<boolean>(false);
  const titleChangeHandler = (e) => {
    setTitle(e.target.value);
  };
  const citationChangeHandler = (e) => {
    setCitation(e.target.value);
  };
  const lexileLevelChangeHandler = (e) => {
    setLexileLevel(e.target.value);
  };
  const notesChangeHandler = (e) => {
    setNotes(e.target.value);
  };
  const notesESChangeHandler = (e) => {
    setNotesES(e.target.value);
  };
  const handleDataTypeChange = (selectedItem) => {
    setSelectedDataType(selectedItem);
  };

  const handleSourceTypeChange = (selectedItem) => {
    setSelectedSourceType(selectedItem);
  };

  const handleDifficultyChange = (selectedItem) => {
    setSelectedDifficulty(selectedItem);
  };

  const handleLiteratureChange = (selectedItem) => {
    setSelectedLiterature(selectedItem);
  };

  const handleGrammarChange = (selectedItem) => {
    setSelectedGrammar(selectedItem);
  };

  const handleGradeChange = (selectedItem) => {
    setSelectedGrade(selectedItem);
  };

  const handleCategoryChange = (selectedItem) => {
    setSelectedCategory(selectedItem);
  };

  const handleCategoryOldChange = (selectedItem) => {
    setSelectedCategoryOld(selectedItem);
  };

  const flLevelChangeHandler = (e) => {
    setFlLevel(e.target.value);
  };
  const activeChangeHandler = () => {
    setIsActive(!isActive);
  };
  const ClassificationChangeHandler = (e) => {
    setSelectedClassification(e);
    setClassification(e.value);
  };
  const approvedChangeHandler = () => {
    setIsApproved(!isApproved);
  };
  const disableChangeHandler = () => {
    setDisablePassageTTS(!disablePassageTTS);
  };
  const handleSaveTags = (tags) => {
    const selectedTagIds = tags
      .filter((tag) => tag.selected === true)
      .map((tag) => tag.tagId);

    const tag = {
      passageId: editedPassageId ? editedPassageId : passageId,
      tagId: selectedTagIds,
    };
    postPassageTag(tag);
  };

  const handleRemoveTag = (allTags, tag) => {
    const selectedTagIds = allTags
      .filter((t) => t.selected === true)
      .map((t) => t.tagId);

    const tagParam = {
      passageId: editedPassageId ? editedPassageId : passageId,
      tagId: tag.tagId,
    };
    setSelectedTagIds(selectedTagIds);
    deletePassageTag(tagParam);
  };

  const [questionToPreview, setQuestionToPreview] = useState<
    IQuestion | undefined
  >();

  let passageInput: any = {};
  if (selectedPassageType === 2) {
    passageInput["passageId"] = passageId;
    passageInput["passages"] = [englishPassageInfo];
    passageInput["englishPassageReferenceId"] = englishPsgReferenceId;
    passageInput["spanishPassageReferenceId"] = spanishPsgReferenceId;
    passageInput["combinedPassageReferenceId"] = combinePsgReferenceId;
    passageInput["questionRefIds"] = associateQuestionIds;
    passageInput["englishWordCount"] = englishWordCount;
    passageInput["spanishWordCount"] = spanishWordCount;
    passageInput["englishPassage"] = englishPassage;
    passageInput["disablePassageTTS"] = disablePassageTTS;
    passageInput["passageTypeId"] = selectedPassageType;
    passageInput["isActive"] = isActive;
    passageInput["isApproved"] = isApproved;
    passageInput["userId"] = props.profile?.userId;
    passageInput["passageClassificationId"] =
      selectedClassification.value === "0"
        ? undefined
        : selectedClassification?.value;
    passageInput["isMachineTranslated"] = isMachineTranslated;
    passageInput["isHumanTranslated"] = isHumanTranslated;
    passageInput["isAIAssisted"] = isAIAssisted;
  } else {
    passageInput = {
      userId: props.profile?.userId,
      passageId: passageId,
      title: title === "" ? undefined : title,
      citation: citation === "" ? undefined : citation,
      lexileLevel: lexileLevel === "" ? undefined : lexileLevel,
      notes: notes === "" ? undefined : notes,
      spanishNotes: notesES === "" ? undefined : notesES,
      flLevel: flLevel === "" ? undefined : flLevel,
      englishPassage: englishPassage,
      spanishPassage: spanishPassage,
      passageGrammarTypeId:
        selectedGrammar?.value === "0" ? undefined : selectedGrammar?.value,
      passageDateTypeId:
        selectedDataType?.value === "0" ? undefined : selectedDataType?.value,
      passageSourceTypeId:
        selectedSourceType?.value === "0"
          ? undefined
          : selectedSourceType?.value,
      passageDifficultyTypeId:
        selectedDifficulty?.value === "0"
          ? undefined
          : selectedDifficulty?.value,
      passageLiteratureTypeId:
        selectedLiterature?.value === "0"
          ? undefined
          : selectedLiterature?.value,
      passageCategoryOldTypeId:
        selectedCategoryOld?.value === "0"
          ? undefined
          : selectedCategoryOld?.value,
      passageCategoryId:
        selectedCategory?.value === "0" ? undefined : selectedCategory?.value,
      isActive: isActive,
      isApproved: isApproved,
      gradeId: selectedGrade?.value === "0" ? undefined : selectedGrade?.value,
      disablePassageTTS: disablePassageTTS,
      passages: [englishPassageInfo],
      englishPassageReferenceId: englishPsgReferenceId,
      spanishPassageReferenceId: spanishPsgReferenceId,
      combinedPassageReferenceId: combinePsgReferenceId,
      questionRefIds: associateQuestionIds,
      passageClassificationId:
        selectedClassification.value === "0"
          ? undefined
          : selectedClassification?.value,
      englishWordCount: englishWordCount,
      spanishWordCount: spanishWordCount,
      passageTypeId: selectedPassageType,
      isMachineTranslated: isMachineTranslated,
      isHumanTranslated: isHumanTranslated,
      isAIAssisted: isAIAssisted,
    };
  }

  const getPassageSpeechRequest = async (text: string, language: Language) => {
    const contentText = await getTextFromLearnosityPassageContent(
      text,
      language
    );
    return {
      language: language,
      text: contentText.substring(0, constant.TTS.MAX_LENGTH_STORAGE_TTS),
    };
  };

  const getPassagePagesContent = async (
    englishPassage: any,
    spanishPassage: any
  ) => {
    const pages = englishPassage.pages;
    const pagesContent = [] as IPassageSpeech[];
    let pageindex = 0;
    for (const page of pages) {
      pagesContent.push(await getPassageSpeechRequest(page, "en"));
      if (spanishPassage?.pages && spanishPassage.pages[pageindex]) {
        pagesContent.push(
          await getPassageSpeechRequest(spanishPassage.pages[pageindex], "es")
        );
      }
      pageindex++;
    }
    return pagesContent;
  };

  const getPassageTextContent = async (
    englishPassage: any,
    spanishPassage: any
  ) => {
    const passagesTextContent = [] as IPassageSpeech[];
    passagesTextContent.push(
      await getPassageSpeechRequest(englishPassage.content, "en")
    );
    if (spanishPassage?.content) {
      passagesTextContent.push(
        await getPassageSpeechRequest(spanishPassage.content, "es")
      );
    }
    return passagesTextContent;
  };

  const updatePassageTTS = async () => {
    try {
      const englishPassage = app?.getWidget();
      const spanishPassage = appES?.getWidget();
      const englishEmptyData =
        !englishPassage || !(englishPassage?.content || englishPassage?.pages);
      const spanishEmptyData =
        !spanishPassage || !(spanishPassage?.content || spanishPassage?.pages);

      if (englishEmptyData && spanishEmptyData) return;
      let content: IPassageSpeech[] = [];
      if (englishPassage?.content) {
        content = await getPassageTextContent(englishPassage, spanishPassage);
      } else {
        content = await getPassagePagesContent(englishPassage, spanishPassage);
      }
      const passages = content.filter(
        (passage) => passage?.text?.length > constant.TTS.MIN_LENGTH_STORAGE_TTS
      );
      if (passages.length > 0) await createPassageSpeech(0, passages);
    } catch (_error) {
      toast.error("Couldn't create text to speech audios");
      throw _error;
    }
  };

  // Guard before any state is touched so a rejected save leaves the editor untouched.
  const hasOnlyUploadedImages = () => {
    const disallowed = [
      ...findDisallowedImageSources(app?.getWidget()),
      ...findDisallowedImageSources(appES?.getWidget()),
    ];
    if (disallowed.length === 0) return true;
    toast.error(constant.PastedImageErrors.Passage);
    return false;
  };

  const passageSubmitHandler = async (e) => {
    e.preventDefault();
    if (!hasOnlyUploadedImages()) return;
    setErrorMessage(true);
    if (app !== undefined) {
      const passageDataEn: IPassageData = app.getWidget();
      const enpinfo: IPassageInfo = {
        type: app.getWidget()["type"],
        reference: app.getItem()["item"]["reference"],
        data: {
          type: passageDataEn?.type,
          content: passageDataEn?.content ? passageDataEn.content : undefined,
          heading: passageDataEn?.heading,
          instructorStimulus: passageDataEn?.instructor_stimulus
            ? passageDataEn.instructor_stimulus
            : undefined,
          isMath: passageDataEn?.is_math ? passageDataEn.is_math : undefined,
          metadata: passageDataEn?.metadata
            ? passageDataEn.metadata
            : undefined,
          pages: passageDataEn?.pages ? passageDataEn.pages : undefined,
          paginatedContent: passageDataEn?.paginated_content
            ? passageDataEn.paginated_content
            : undefined,
        },
      };
      setEnglishPassage(passageDataEn?.content ? passageDataEn.content : "");
      passageInput.englishPassage = passageDataEn?.content
        ? passageDataEn.content
        : undefined;

      passageInput.passages[0] = enpinfo;
      setEnglishPassageInfo(enpinfo);
      passageInput.englishWordCount = GetEnglishWordCount();
      if (appES !== undefined) {
        const passageDataEs: IPassageData = appES.getWidget();
        const espinfo: IPassageInfo = {
          type: appES.getWidget()["type"],
          reference: appES.getItem()["item"]["reference"],
          data: {
            type: passageDataEs?.type,
            content: passageDataEs?.content ? passageDataEs.content : undefined,
            heading: passageDataEs?.heading,
            instructorStimulus: passageDataEs?.instructor_stimulus
              ? passageDataEs.instructor_stimulus
              : undefined,
            isMath: passageDataEs?.is_math ? passageDataEs.is_math : undefined,
            metadata: passageDataEs?.metadata
              ? passageDataEs.metadata
              : undefined,
            pages: passageDataEs?.pages ? passageDataEs.pages : undefined,
            paginatedContent: passageDataEs?.paginated_content
              ? passageDataEs.paginated_content
              : undefined,
          },
        };
        setSpanishPassage(passageDataEs?.content ? passageDataEs.content : "");
        passageInput.spanishPassage = passageDataEs?.content
          ? passageDataEs.content
          : undefined;

        setSpanishPassageInfo(espinfo);
        passageInput.passages[1] = espinfo;
        passageInput.spanishWordCount = GetSpanishWordCount(espinfo.data);
      } else if (managePassage === undefined && editedPassageId === "") {
        setSpanishPassage(app.getWidget()["heading"]);
        passageInput.spanishPassage = app.getWidget()["heading"];
        const espinfo: IPassageInfo = {
          type: enpinfo.type,
          reference: spanishPsgReferenceId,
          data: enpinfo.data,
        };
        setSpanishPassageInfo(espinfo);
        passageInput.passages[1] = espinfo;
        passageInput.spanishWordCount = GetSpanishWordCount(espinfo.data);
      }
    }

    if (notes) {
      passageInput.notes = notes;
    }

    if (!notesES) {
      setNotesES(notes);
      passageInput.spanishNotes = notes;
    } else {
      setNotesES(notesES);
      passageInput.spanishNotes = notesES;
    }
    if (selectedContentArea.value != "0") {
      passageInput.contentAreaId = selectedContentArea?.value;
    }

    if (editedPassageId !== "" || (passageId !== undefined && passageId > 0)) {
      try {
        setLoading(true);
        await updatePassage(passageInput);
        await updatePassageTTS();
        setLoading(false);
        toast.success("Passage updated successfully");

        if (passageId !== undefined && passageId > 0) {
          navigate(constant.EDITPASSAGE.replace(":id", passageId.toString()));
        } else {
          setTimeout(() => {
            navigate(constant.PASSAGE);
          }, 1500);
        }
      } catch (e) {
        toast.error("Something went wrong");
        setLoading(false);
      }
    } else {
      try {
        setLoading(true);
        const response = await postPassage(passageInput);
        const newPassageId = response.data;
        await updatePassageTTS();
        setLoading(false);
        toast.success("Passage saved successfully");
        navigate(constant.EDITPASSAGE.replace(":id", newPassageId));
      } catch (e) {
        toast.error("Something went wrong");
        setLoading(false);
      }
    }
  };

  function UpdatePassageAndRedirectToQuestion() {
    if (app !== undefined) {
      setEnglishPassage(app.getWidget()["heading"]);
      passageInput.englishPassage = app.getWidget()["heading"];
      const passageDataEn: IPassageData = app.getWidget();
      const enpinfo: IPassageInfo = {
        type: app.getWidget()["type"],
        reference: app.getItem()["item"]["reference"],
        data: {
          type: passageDataEn?.type,
          content: passageDataEn?.content ? passageDataEn.content : undefined,
          heading: passageDataEn?.heading,
          instructorStimulus: passageDataEn?.instructor_stimulus
            ? passageDataEn.instructor_stimulus
            : undefined,
          isMath: passageDataEn?.is_math ? passageDataEn.is_math : undefined,
          metadata: passageDataEn?.metadata
            ? passageDataEn.metadata
            : undefined,
          pages: passageDataEn?.pages ? passageDataEn.pages : undefined,
          paginatedContent: passageDataEn?.paginated_content
            ? passageDataEn.paginated_content
            : undefined,
        },
      };
      passageInput.passages[0] = enpinfo;
      setEnglishPassageInfo(enpinfo);
      if (appES !== undefined) {
        const passageDataEs: IPassageData = appES.getWidget();
        const espinfo: IPassageInfo = {
          type: appES.getWidget()["type"],
          reference: appES.getItem()["item"]["reference"],
          data: {
            type: passageDataEs?.type,
            content: passageDataEs?.content ? passageDataEs.content : undefined,
            heading: passageDataEs?.heading,
            instructorStimulus: passageDataEs?.instructor_stimulus
              ? passageDataEs.instructor_stimulus
              : undefined,
            isMath: passageDataEs?.is_math ? passageDataEs.is_math : undefined,
            metadata: passageDataEs?.metadata
              ? passageDataEs.metadata
              : undefined,
            pages: passageDataEs?.pages ? passageDataEs.pages : undefined,
            paginatedContent: passageDataEs?.paginated_content
              ? passageDataEs.paginated_content
              : undefined,
          },
        };
        setSpanishPassage(appES.getWidget()["heading"]);
        passageInput.spanishPassage = appES.getWidget()["heading"];
        setSpanishPassageInfo(espinfo);
        passageInput.passages[1] = espinfo;
      } else if (managePassage === undefined && editedPassageId === "") {
        setSpanishPassage(app.getWidget()["heading"]);
        passageInput.spanishPassage = app.getWidget()["heading"];
        const espinfo: IPassageInfo = {
          type: enpinfo.type,
          reference: spanishPsgReferenceId,
          data: enpinfo.data,
        };
        setSpanishPassageInfo(espinfo);
        passageInput.passages[1] = espinfo;
      }
    }
    if (!notesES) {
      setNotesES(notes);
      passageInput.spanishNotes = notes;
    } else {
      setNotesES(notesES);
      passageInput.spanishNotes = notesES;
    }
    updatePassage(passageInput);
    RedirectToAddQuestion();
  }

  const RedirectToAddQuestion = () => {
    navigate(constant.AUTHORQUESTION, {
      state: {
        questionIdToEdit: null,
        associatedPassageId: passageId,
        associatedPassageTitle: title,
        associatedEnglishPsgRefId: englishPsgReferenceId,
        associatedSpanishPsgRefId: spanishPsgReferenceId,
        passageClassification: selectedClassification.label,
      },
    });
  };

  function WordCount(str) {
    return (
      str
        .trim()
        // eslint-disable-next-line no-control-regex
        .split(new RegExp(" |\n"))
        .filter(function (n) {
          return n != "";
        }).length
    );
  }
  const breadcrumbItems = () => {
    const items: Array<IBreadcrumb> = [
      { name: "Passage", url: constant.PASSAGE },
      {
        name: editedPassageId !== "" ? "Edit Passage" : "Add Passage",
        url: "",
      },
    ];

    if (passageId) {
      items.push({ name: passageId ? passageId.toString() : "", url: "" });
    }

    return items;
  };

  const handleRedirect = (editedPassageId) => {
    if (editedPassageId) {
      navigate(constant.PASSAGEQUESTIONS, {
        state: {
          editedPassageId: editedPassageId,
          englishPassageRefId: englishPsgReferenceId,
          spanishPassageRefId: spanishPsgReferenceId,
        },
      });
    } else {
      toast.warning("Unable to find passage id, Please retry!");
    }
  };

  const handleEditQuestion = (questionId) => {
    navigate(constant.MANAGEQUESTION.replace(":id", questionId.toString()));
  };

  const deletePassageAssociateQuestion = (
    questionId,
    englishQuestionReferenceId,
    spanishQuestionReferenceId
  ) => {
    setShowDeleteModal(true);
    setAssociateQuestionId(questionId);
    setAssociateEnglishQuestionId(englishQuestionReferenceId);
    setAssociateSpanishQuestionId(spanishQuestionReferenceId);
  };

  const deleteRecordHandler = () => {
    deleteAssociateQuestion(
      passageId,
      associateQuestionId,
      userId,
      associateEnglishQuestionId,
      associateSpanishQuestionId,
      englishPsgReferenceId,
      spanishPsgReferenceId
    ).then((res) => {
      setShowDeleteModal(false);
      getAssociateQuestion();
    });
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
  };

  async function bindGrade(editedPassage) {
    const service = await import("../../../api/grade.service");
    service.getAllgrade().then((response) => {
      let newGrade = [];
      if (response.data.data.length > 0) {
        newGrade = response.data.data.map((element) => {
          return {
            value: element.gradeId || 0,
            label: `${element.name}`,
          };
        });
        if (editedPassage === "") {
          setSelectedGrade(defaultValue);
        } else {
          const assignedValue = response.data.data.filter(
            (thisData) => thisData.gradeId === editedPassage.gradeId
          );
          const dropdownInitializer = {
            value: assignedValue[0]?.gradeId,
            label: assignedValue[0]?.name,
          };
          setSelectedGrade(dropdownInitializer);
        }
      }
      setGrade(defaultElement.concat(newGrade));
    });
  }

  function bindDataType(editedPassage) {
    getPassagesDataType().then((response) => {
      let newDataType = [];
      if (response.data.length > 0) {
        newDataType = response.data.map((element) => {
          return {
            value: element.id || 0,
            label: `${element.name}`,
          };
        });
        if (editedPassage === "") {
          setSelectedDataType(defaultValue);
        } else {
          const assignedValue = response.data.filter(
            (thisData) => thisData.id === editedPassage.passageDateTypeId
          );
          const dropdownInitializer = {
            value: assignedValue[0]?.id,
            label: assignedValue[0]?.name,
          };
          setSelectedDataType(dropdownInitializer);
        }
      }
      setDataType(defaultElement.concat(newDataType));
    });
  }

  function bindGrammarType(editedPassage) {
    getPassagesGrammarType().then((response) => {
      let newGrammarType = [];
      if (response.data.length > 0) {
        newGrammarType = response.data.map((element) => {
          return {
            value: element.id || 0,
            label: `${element.name}`,
          };
        });
        if (editedPassage === "") {
          setSelectedGrammar(defaultValue);
        } else {
          const assignedValue = response.data.filter(
            (thisData) => thisData.id === editedPassage.passageGrammarTypeId
          );
          const dropdownInitializer = {
            value: assignedValue[0]?.id,
            label: assignedValue[0]?.name,
          };
          setSelectedGrammar(dropdownInitializer);
        }
      }
      setGrammarType(defaultElement.concat(newGrammarType));
    });
  }

  function bindSourceType(editedPassage) {
    getPassagessourceType().then((response) => {
      let newSourceType = [];
      if (response.data.length > 0) {
        newSourceType = response.data.map((element) => {
          return {
            value: element.id || 0,
            label: `${element.name}`,
          };
        });
        if (editedPassage === "") {
          setSelectedSourceType(defaultValue);
        } else {
          const assignedValue = response.data.filter(
            (thisData) => thisData.id === editedPassage.passageSourceTypeId
          );
          const dropdownInitializer = {
            value: assignedValue[0]?.id,
            label: assignedValue[0]?.name,
          };
          setSelectedSourceType(dropdownInitializer);
        }
      }
      setSourceType(defaultElement.concat(newSourceType));
    });
  }

  function bindDifficultyType(editedPassage) {
    getPassagesdifficultyType().then((response) => {
      let newDifficultyType = [];
      if (response.data.length > 0) {
        newDifficultyType = response.data.map((element) => {
          return {
            value: element.id || 0,
            label: `${element.name}`,
          };
        });
        if (editedPassage === "") {
          setSelectedDifficulty(defaultValue);
        } else {
          const assignedValue = response.data.filter(
            (thisData) => thisData.id === editedPassage.passageDifficultyTypeId
          );
          const dropdownInitializer = {
            value: assignedValue[0]?.id,
            label: assignedValue[0]?.name,
          };
          setSelectedDifficulty(dropdownInitializer);
        }
      }
      setDifficultyType(defaultElement.concat(newDifficultyType));
    });
  }

  function bindLiteratureType(editedPassage) {
    getPassagesliteratureType().then((response) => {
      let newLiteratureType = [];
      if (response.data.length > 0) {
        newLiteratureType = response.data.map((element) => {
          return {
            value: element.id || 0,
            label: `${element.name}`,
          };
        });
        if (editedPassage === "") {
          setSelectedLiterature(defaultValue);
        } else {
          const assignedValue = response.data.filter(
            (thisData) => thisData.id === editedPassage.passageLiteratureTypeId
          );
          const dropdownInitializer = {
            value: assignedValue[0]?.id,
            label: assignedValue[0]?.name,
          };
          setSelectedLiterature(dropdownInitializer);
        }
      }

      setLiteratureType(defaultElement.concat(newLiteratureType));
    });
  }

  function bindCategoryType(editedPassage) {
    getPassagesCategory().then((response) => {
      let newCategoryType = [];
      if (response.data.length > 0) {
        newCategoryType = response.data.map((element) => {
          return {
            value: element.passageCategoryId || 0,
            label: `${element.name}`,
          };
        });
        if (editedPassage === "") {
          setSelectedCategory(defaultValue);
        } else {
          const assignedValue = response.data.filter(
            (thisData) =>
              thisData.passageCategoryId === editedPassage?.passageCategoryId
          );
          if (assignedValue?.length) {
            const dropdownInitializer = {
              value: assignedValue[0]?.passageCategoryId,
              label: assignedValue[0]?.name,
            };
            setSelectedCategory(dropdownInitializer);
          }
        }
      }
      setCategory(defaultElement.concat(newCategoryType));
    });
  }

  function bindCategoryOldType(editedPassage) {
    getPassagesCategoryOld().then((response) => {
      let newCategoryOldType = [];
      if (response.data.length > 0) {
        newCategoryOldType = response.data.map((element) => {
          return {
            value: element.id || 0,
            label: `${element.name}`,
          };
        });
        if (editedPassage === "") {
          setSelectedCategoryOld(defaultValue);
        } else {
          const assignedValue = response.data.filter(
            (thisData) => thisData.id === editedPassage.passageCategoryOldTypeId
          );
          const dropdownInitializer = {
            value: assignedValue[0]?.id,
            label: assignedValue[0]?.name,
          };
          setSelectedCategoryOld(dropdownInitializer);
        }
      }
      setcategoryOld(defaultElement.concat(newCategoryOldType));
    });
  }

  function bindAllTag(editedPassage) {
    if (editedPassage && editedPassage !== "" && editedPassage.length > 0) {
      const tagIds = editedPassage.map((item) => item.tagId);
      setSelectedTagIds(tagIds);
    }
  }
  function bindClassification(editedPassage) {
    getClassifications().then((response) => {
      let newClassification = [];
      if (response.data.length > 0) {
        newClassification = response.data.map((element) => {
          return {
            value: element.passageClassificationId || 0,
            label: `${element.name}`,
          };
        });
        if (editedPassage === "") {
          setSelectedClassification(defaultValue);
        } else {
          const assignedValue = response.data.filter(
            (thisData) =>
              thisData.passageClassificationId ===
              editedPassage.passageClassificationId
          );
          const dropdownInitializer = {
            value: assignedValue[0]?.passageClassificationId,
            label: assignedValue[0]?.name,
          };
          setSelectedClassification(dropdownInitializer);
          setClassification(dropdownInitializer.value);
        }
      }
      setPassageClassification(newClassification);
    });
  }

  async function getAssociateQuestion() {
    if (editedPassageId) {
      setLoading(true);
      const associateQuestionResponse = getAssociatePassage(
        editedPassageId,
        pageSize,
        pageNumber
      );
      const questionType = (await associateQuestionResponse).data;

      setAssociateQuestion(questionType.data);
      setTotalPages(Math.ceil(questionType.totalRecords / pageSize));
      setTotalRecords(questionType.totalRecords);
      setLoading(false);
      const questionIds: string[] = [];
      questionType.data.map((question, index) => {
        questionIds.push(question.englishQuestionReferenceId);
        questionIds.push(question.spanishQuestionReferenceId);
      });
      setAssociateQuestionIds(questionIds);
    }
  }

  function getPassageDataById() {
    setLoading(true);
    editedPassageId &&
      getPassageById(editedPassageId).then((response) => {
        setLoading(false);

        if (response.data) {
          setEnglishPsgReferenceId(response.data?.englishPassageReferenceId);
          setSpanishPsgReferenceId(response.data?.spanishPassageReferenceId);
          setCombinePsgReferenceId(response.data?.combinedPassageReferenceId);
          setPassageId(response.data?.passageId);
          setTitle(response.data?.title);
          setCitation(response.data?.citation);
          setLexileLevel(response.data?.lexileLevel);
          setFlLevel(response.data?.flLevel);
          setNotes(response.data?.notes);
          setNotesES(response.data?.spanishNotes);
          setIsApproved(response.data?.isApproved);
          setIsActive(response.data?.isActive);
          setDisablePassageTTS(response.data?.disablePassageTTS);
          setEditedPassage(response.data);
          bindGrammarType(response.data);
          bindCategoryType(response.data);
          bindDataType(response.data);
          bindDifficultyType(response.data);
          bindGrade(response.data);
          bindLiteratureType(response.data);
          bindCategoryType(response.data);
          bindSourceType(response.data);
          bindCategoryOldType(response.data);
          bindAllTag(response.data?.tags);
          setEnglishPassage(response.data);
          setManageTags(true);
          bindClassification(response.data);
          if (response.data?.passageClassificationId) {
            setClassification(response.data.passageClassificationId);
          } else {
            setClassification(undefined);
          }
          setEnglishWordCount(response.data?.englishWordCount);
          setSpanishWordCount(response.data?.spanishWordCount);
          setSelectedPassageType(response?.data?.passageTypeId);
          if (response.data?.contentAreaId) {
            bindContentArea(response.data?.contentAreaId);
          }
          setIsMachineTranslated(response.data?.isMachineTranslated);
          setIsHumanTranslated(response.data?.isHumanTranslated);
          setIsAIAssisted(response.data?.isAIAssisted);
        }
      });
  }

  const SetEnglishPassageData = () => {
    if (app !== undefined) {
      setWidgetPsgEN(app.getWidget());
      setEnglishPassage(app.getWidget()["content"]);
      GetEnglishWordCount();
    }
  };

  const SetSpanishPassageData = () => {
    if (appES !== undefined) {
      setWidgetPsgES(appES.getWidget());
      setSpanishPassage(appES.getWidget()["content"]);
      GetSpanishWordCount(undefined);
    }
  };

  const GetEnglishWordCount = () => {
    let wordCount = 0;
    if (app.getWidget()["content"]) {
      if (isLrnPaginated) {
        setTimeout(function () {
          setIsLrnPaginated(false);
        }, 3000);
      }
      wordCount = WordCount(app.getWidget()["content"]);
    } else if (app.getWidget()["paginated_content"]) {
      if (!isLrnPaginated) {
        setTimeout(function () {
          setIsLrnPaginated(true);
        }, 3000);
      }
      let contentStr = "";
      if (app.getWidget()["pages"]) {
        for (let i = 0; i < app.getWidget()["pages"].length; i++) {
          contentStr += " " + app.getWidget()["pages"][i];
        }
      }
      wordCount = WordCount(contentStr);
    }
    setEnglishWordCount(wordCount);
    return wordCount;
  };

  const GetSpanishWordCount = (data) => {
    let wordCount = 0;
    if (appES !== undefined && data === undefined) {
      if (appES.getWidget()["content"]) {
        if (isLrnSpanishPaginated) {
          setTimeout(function () {
            setIsLrnSpanishPaginated(false);
          }, 3000);
        }
        wordCount = WordCount(appES.getWidget()["content"]);
      } else if (appES.getWidget()["paginated_content"]) {
        let contentStr = "";
        if (!isLrnSpanishPaginated) {
          setTimeout(function () {
            setIsLrnSpanishPaginated(true);
          }, 3000);
        }
        if (appES.getWidget()["pages"]) {
          for (let i = 0; i < appES.getWidget()["pages"].length; i++) {
            contentStr += " " + appES.getWidget()["pages"][i];
          }
        }
        wordCount = WordCount(contentStr);
      }
    } else {
      if (data.content) {
        if (isLrnSpanishPaginated) {
          setTimeout(function () {
            setIsLrnSpanishPaginated(false);
          }, 3000);
        }
        wordCount = WordCount(data.content);
      } else if (data.paginatedContent) {
        let contentStr = "";
        if (!isLrnSpanishPaginated) {
          setTimeout(function () {
            setIsLrnSpanishPaginated(true);
          }, 3000);
        }
        if (data.pages) {
          for (let i = 0; i < data.pages.length; i++) {
            contentStr += " " + data.pages[i];
          }
        }
        wordCount = WordCount(contentStr);
      }
    }
    setSpanishWordCount(wordCount);
    return wordCount;
  };

  useEffect(() => {
    if (appES !== undefined) {
      setWidgetPsgES(appES.getWidget());
      setSpanishPassage(appES.getWidget()["content"]);
    }
  }, [appES]);

  useEffect(() => {
    if (editedPassageId === "" && !showPassageTypeModal) {
      setLoading(true);
      postPassage(passageInput).then((response: any) => {
        setLoading(false);
        setManageTags(true);
        setPassageId(response.data);
      });
    }
    getContent();
  }, [showPassageTypeModal]);

  useEffect(() => {
    if (passageId !== undefined && passageId !== 0) {
      if (
        (englishPsgReferenceId === undefined || englishPsgReferenceId === "") &&
        (spanishPsgReferenceId === undefined || spanishPsgReferenceId == "")
      ) {
        setEnglishPsgReferenceId(passageId + "-p-en");
        setSpanishPsgReferenceId(passageId + "-p-es");
        setCombinePsgReferenceId(passageId + "-p");
      }
      if (englishPsgReferenceId && spanishPsgReferenceId) {
        setPassageEditor(
          <PassageEditorTabs
            App={app}
            authorAppParent={setAuthorApp}
            widgetPsgDataEN={widgetPsgDataEN}
            setWidgetPsgEN={setWidgetPsgEN}
            authorAppParentES={setAuthorAppES}
            widgetPsgDataES={widgetPsgDataES}
            setWidgetPsgES={setWidgetPsgES}
            englishPassage={englishPassage}
            errorMessage={errorMessage}
            notes={notes}
            notesChangeHandler={notesChangeHandler}
            notesES={notesES}
            notesESChangeHandler={notesESChangeHandler}
            SetSpanishPassageData={SetSpanishPassageData}
            SetEnglishPassageData={SetEnglishPassageData}
            englishPsgReferenceId={englishPsgReferenceId}
            spanishPsgReferenceId={spanishPsgReferenceId}
            widgetDataOnLoad={widgetDataOnLoad}
            englishWordCount={englishWordCount}
            spanishWordCount={spanishWordCount}
            setIsLrnEditorLoaded={setIsLrnEditorLoaded}
            setIsLrnSpanishEditorLoaded={setIsLrnSpanishEditorLoaded}
            setIsLrnPaginated={setIsLrnPaginated}
            setIsLrnSpanishPaginated={setIsLrnSpanishPaginated}
            setSelectedLanguage={setSelectedLanguage}
            setLoading={setLoading}
            setIsHumanTranslated={setIsHumanTranslated}
            isHumanTranslated={isHumanTranslated}
          />
        );
      }
    } else {
      setPassageEditor("");
    }
  }, [
    app,
    passageId,
    widgetPsgDataEN,
    widgetPsgDataES,
    widgetDataOnLoad,
    englishPsgReferenceId,
    spanishPsgReferenceId,
    errorMessage,
    notes,
    notesES,
    englishPassage,
    englishWordCount,
    spanishWordCount,
    isHumanTranslated,
  ]);

  useEffect(() => {
    if (isLoaded) {
      if (editedPassageId) getPassageDataById();
      bindGrade("");
      bindGrammarType("");
      bindSourceType("");
      bindDifficultyType("");
      bindDataType("");
      bindLiteratureType("");
      bindCategoryType("");
      bindCategoryOldType("");
      bindAllTag("");
      getAssociateQuestion();
      bindClassification("");
    }
  }, [pageNumber]);

  useEffect(() => {
    if (pageNumber === 1) {
      if (editedPassageId) getPassageDataById();
      bindGrade("");
      bindGrammarType("");
      bindSourceType("");
      bindDifficultyType("");
      bindDataType("");
      bindLiteratureType("");
      bindCategoryType("");
      bindCategoryOldType("");
      bindAllTag("");
      getAssociateQuestion();
      bindClassification("");
      setIsLoaded(true);
    } else {
      paginationRef?.current?.onReset();
    }
  }, [pageSize]);

  useEffect(() => {
    if (
      (islrneditorloaded && !isLrnPaginated) ||
      (islrnspanisheditorloaded && !isLrnSpanishPaginated)
    ) {
      const elements: HTMLCollection = document.getElementsByClassName(
        "cke_textarea_inline"
      );
      if (elements.length > 0) {
        for (const element of elements) {
          // Create an observer instance.
          const observer = new MutationObserver(function (mutations) {
            if (selectedLanguage === "EN") {
              GetEnglishWordCount();
            } else {
              GetSpanishWordCount(undefined);
            }
          });

          // Pass in the target node, as well as the observer options.
          observer.observe(element, {
            attributes: true,
            childList: true,
            characterData: true,
          });
        }
      }
    }
  }, [
    islrneditorloaded,
    islrnspanisheditorloaded,
    isLrnPaginated,
    isLrnSpanishPaginated,
  ]);

  useEffect(() => {
    if (isLrnPaginated || isLrnSpanishPaginated) {
      const elements: any = document.getElementsByClassName("lrn-qe-draggable");
      if (elements.length > 0) {
        const observer = new MutationObserver(function (mutations) {
          if (selectedLanguage === "EN") {
            GetEnglishWordCount();
          } else {
            GetSpanishWordCount(undefined);
          }
        });
        // Pass in the target node, as well as the observer options.
        observer.observe(elements[0], {
          attributes: true,
          childList: true,
          characterData: true,
          attributeOldValue: true,
          characterDataOldValue: true,
          subtree: true,
        });
      }
    }
    //}
  }, [isLrnPaginated, islrnspanisheditorloaded]);

  const onPassageTypeChange = (type) => {
    setSelectedPassageType(type);
    setShowPassageTypeModal(false);
  };
  const openModal = (id, questionId, question) => {
    setOpen(true);
    setPreviewId(id);
    setQuestionIdPreview(questionId);
    setQuestionToPreview(question);
  };

  const popUpClose = (value) => {
    setOpen(value);
    setPreviewId("");
    setQuestionIdPreview(undefined);
    setQuestionToPreview(undefined);
  };
  const getContent = async () => {
    const service = await import("../../../api/contentArea.service");
    const response = service.getContentArea(999, 1);
    const data = (await response).data;
    let dropdownData = [];
    if (data.data.length > 0) {
      dropdownData = data.data.map((eachContentData) => {
        return {
          value: eachContentData.contentAreaId || 0,
          label: `${eachContentData.name}`,
        };
      });
    }
    setContentArea(dropdownData);
  };

  const handleContenAreaChange = (e) => {
    setselectedContentArea(e);
  };
  function bindContentArea(contentAreaId) {
    getContentArea(999, 1).then((response) => {
      if (response.data.data.length > 0) {
        const assignedValue = response.data.data.filter(
          (thisData) => thisData.contentAreaId === contentAreaId
        );
        const dropdownInitializer = {
          value: assignedValue[0]?.contentAreaId,
          label: assignedValue[0]?.name,
        };
        setselectedContentArea(dropdownInitializer);
      }
    });
  }
  useEffect(() => {
    if (!isHumanTranslated) {
      setIsMachineTranslated(isApproved);
    }
  }, [isApproved, isHumanTranslated]);
  useEffect(() => {
    if (isHumanTranslated) {
      setIsMachineTranslated(!isHumanTranslated);
    }
  }, [isHumanTranslated]);
  return (
    <AllowedTo
      perform={[Permissions.passage_create, Permissions.passage_modify]}
      no={() => <AccessDenied />}
    >
      {loading && <Loader />}
      <PreviewModal
        modal={openModal}
        show={open}
        changeValue={popUpClose}
        itemRef={previewId}
        questionIdPreview={questionIdPreview}
        questionIndexPreview={questionIndexPreview}
        setQuestionIndexPreview={setQuestionIndexPreview}
        questions={associateQuestion}
        setQuestionIdPreview={setQuestionIdPreview}
        setPreviewId={setPreviewId}
        questionToPreview={questionToPreview}
        setQuestionToPreview={setQuestionToPreview}
      ></PreviewModal>

      {showDeleteModal && (
        <DeleteModal
          closeDeleteModal={closeDeleteModal}
          deleteRecord={deleteRecordHandler}
        />
      )}
      <div className="flex-1 overflow-auto">
        <div className=" h-auto min-h-half w-full rounded-bl-3xl bg-site-teal px-8  py-8 pt-0 pb-14 mt-7 ">
          <div className="relative  py-1">
            <div className="overlay-image-main pointer-events-none fixed left-0 top-0 w-screen h-screen z-20"></div>

            <div>
              <div>
                <h3 className="text-lg font-light text-gray-900">
                  {editedPassageId !== "" ? " Edit passage " : "Add passage "}
                  <Breadcrumb items={breadcrumbItems()} />
                </h3>
              </div>
            </div>
            <div className="border-b pb-6">
              {selectedPassageType !== 2 && (
                <>
                  <div className="grid grid-cols-12 gap-6">
                    <div className="col-span-3 sm:col-span-3">
                      <div className="contentArea">
                        <div>
                          <label className="text-sm text-gray-700">Title</label>
                          <input
                            id="title"
                            name="title"
                            type="text"
                            autoComplete="off"
                            placeholder="Title"
                            value={title}
                            onChange={titleChangeHandler}
                            className="block w-full mt-1 border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                          />
                          {title === "" && errorMessage === true && (
                            <span className="text-red-700 inline-block pt-1 text-sm">
                              Title is required
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-span-3 sm:col-span-3">
                      <div className="contentArea">
                        <div>
                          <label className="text-sm text-gray-700">
                            Citation
                          </label>
                          <input
                            id="citation"
                            name="citation"
                            type="text"
                            autoComplete="off"
                            placeholder="Citation"
                            value={citation}
                            onChange={citationChangeHandler}
                            className="block w-full mt-1 border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                          />
                          {citation === "" && errorMessage === true && (
                            <span className="text-red-700 inline-block pt-1 text-sm">
                              Citation is required
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-span-3 sm:col-span-3">
                      <div className="contentArea">
                        <div>
                          <label className="text-sm text-gray-700">
                            Lexile Level
                          </label>
                          <input
                            id="lexileLevel"
                            name="lexileLevel"
                            type="number"
                            autoComplete="off"
                            placeholder="Lexile Level"
                            value={lexileLevel}
                            min={0}
                            onChange={lexileLevelChangeHandler}
                            className="block w-full mt-1 border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                          />
                          {lexileLevel === "" && errorMessage === true && (
                            <span className="text-red-700 inline-block pt-1 text-sm">
                              Lexile level is required
                            </span>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="col-span-3 sm:col-span-3">
                      <div className="contentArea">
                        <div>
                          <label className="text-sm text-gray-700">
                            Date Type
                          </label>

                          <Select
                            className="w-full mt-1 text-sm"
                            options={dataType}
                            theme={(theme) => ({
                              ...theme,
                              colors: {
                                ...theme.colors,
                                primary25: "#B3B3B3",
                                primary: "#041E42",
                              },
                            })}
                            styles={{
                              control: (base, state) => ({
                                ...base,
                                background:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#1A1C23"
                                    : "white",
                                borderColor:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#6B7280"
                                    : "#D1D5DB",
                                borderWidth: "1px",
                                "&:hover": {
                                  borderColor:
                                    state.isFocused &&
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "#6b7280"
                                      : state.isFocused
                                      ? "#4c5563"
                                      : "",
                                },
                              }),
                              singleValue: (base) => ({
                                ...base,
                                color:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "white"
                                    : "#374051",
                              }),
                              input: (base) => ({
                                ...base,
                                color:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "white"
                                    : "",
                              }),
                            }}
                            onChange={handleDataTypeChange}
                            value={selectedDataType}
                            isSearchable={true}
                          />
                          {selectedDataType.value === "0" &&
                            errorMessage === true && (
                              <span className="text-red-700 inline-block pt-1 text-sm">
                                Date Type is required
                              </span>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="grid grid-cols-12 gap-6 mt-5">
                    <div className="col-span-3 sm:col-span-3 ">
                      <div className="contentArea">
                        <div>
                          <label className="text-sm text-gray-700">
                            Difficulty Type
                          </label>

                          <Select
                            className="w-full mt-1 text-sm"
                            options={difficultyType}
                            theme={(theme) => ({
                              ...theme,
                              colors: {
                                ...theme.colors,
                                primary25: "#B3B3B3",
                                primary: "#041E42",
                              },
                            })}
                            styles={{
                              control: (base, state) => ({
                                ...base,
                                background:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#1A1C23"
                                    : "white",
                                borderColor:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#6B7280"
                                    : "#D1D5DB",
                                borderWidth: "1px",
                                "&:hover": {
                                  borderColor:
                                    state.isFocused &&
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "#6b7280"
                                      : state.isFocused
                                      ? "#4c5563"
                                      : "",
                                },
                              }),
                              singleValue: (base) => ({
                                ...base,
                                color:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "white"
                                    : "#374051",
                              }),
                              input: (base) => ({
                                ...base,
                                color:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "white"
                                    : "",
                              }),
                            }}
                            onChange={handleDifficultyChange}
                            value={selectedDifficulty}
                            isSearchable={true}
                          />
                          {selectedDifficulty.value === "0" &&
                            errorMessage === true && (
                              <span className="text-red-700 inline-block pt-1 text-sm">
                                Difficulty Type is required
                              </span>
                            )}
                        </div>
                      </div>
                    </div>
                    <div className="col-span-3 sm:col-span-3">
                      <div className="contentArea">
                        <div>
                          <label className="text-sm text-gray-700">
                            Literature Type
                          </label>

                          <Select
                            className="w-full mt-1 text-sm"
                            options={literatureType}
                            theme={(theme) => ({
                              ...theme,
                              colors: {
                                ...theme.colors,
                                primary25: "#B3B3B3",
                                primary: "#041E42",
                              },
                            })}
                            styles={{
                              control: (base, state) => ({
                                ...base,
                                background:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#1A1C23"
                                    : "white",
                                borderColor:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#6B7280"
                                    : "#D1D5DB",
                                borderWidth: "1px",
                                "&:hover": {
                                  borderColor:
                                    state.isFocused &&
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "#6b7280"
                                      : state.isFocused
                                      ? "#4c5563"
                                      : "",
                                },
                              }),
                              singleValue: (base) => ({
                                ...base,
                                color:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "white"
                                    : "#374051",
                              }),
                              input: (base) => ({
                                ...base,
                                color:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "white"
                                    : "",
                              }),
                            }}
                            onChange={handleLiteratureChange}
                            value={selectedLiterature}
                            isSearchable={true}
                          />
                          {selectedLiterature.value === "0" &&
                            errorMessage === true && (
                              <span className="text-red-700 inline-block pt-1 text-sm">
                                Literature Type is required
                              </span>
                            )}
                        </div>
                      </div>
                    </div>

                    <div className="col-span-3 sm:col-span-3 contentArea">
                      <div>
                        <label className="text-sm text-gray-700">
                          Grammar Type
                        </label>
                        <Select
                          className="w-full mt-1 text-sm"
                          options={grammarType}
                          theme={(theme) => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                              primary25: "#B3B3B3",
                              primary: "#041E42",
                            },
                          })}
                          styles={{
                            control: (base, state) => ({
                              ...base,
                              background:
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "#1A1C23"
                                  : "white",
                              borderColor:
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "#6B7280"
                                  : "#D1D5DB",
                              borderWidth: "1px",
                              "&:hover": {
                                borderColor:
                                  state.isFocused &&
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#6b7280"
                                    : state.isFocused
                                    ? "#4c5563"
                                    : "",
                              },
                            }),
                            singleValue: (base) => ({
                              ...base,
                              color:
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "white"
                                  : "#374051",
                            }),
                            input: (base) => ({
                              ...base,
                              color:
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "white"
                                  : "",
                            }),
                          }}
                          onChange={handleGrammarChange}
                          value={selectedGrammar}
                          isSearchable={true}
                        />
                        {selectedGrammar.value === "0" &&
                          errorMessage === true && (
                            <span className="text-red-700 inline-block pt-1 text-sm">
                              Grammar Type is required
                            </span>
                          )}
                      </div>
                    </div>
                    <div className="col-span-3 sm:col-span-3">
                      <div className="contentArea">
                        <div>
                          <label className="text-sm text-gray-700">
                            Source Type
                          </label>
                          <Select
                            className="w-full mt-1 text-sm"
                            options={sourceType}
                            theme={(theme) => ({
                              ...theme,
                              colors: {
                                ...theme.colors,
                                primary25: "#B3B3B3",
                                primary: "#041E42",
                              },
                            })}
                            styles={{
                              control: (base, state) => ({
                                ...base,
                                background:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#1A1C23"
                                    : "white",
                                borderColor:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#6B7280"
                                    : "#D1D5DB",
                                borderWidth: "1px",
                                "&:hover": {
                                  borderColor:
                                    state.isFocused &&
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "#6b7280"
                                      : state.isFocused
                                      ? "#4c5563"
                                      : "",
                                },
                              }),
                              singleValue: (base) => ({
                                ...base,
                                color:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "white"
                                    : "#374051",
                              }),
                              input: (base) => ({
                                ...base,
                                color:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "white"
                                    : "",
                              }),
                            }}
                            onChange={handleSourceTypeChange}
                            value={selectedSourceType}
                            isSearchable={true}
                          />{" "}
                          {selectedSourceType.value === "0" &&
                            errorMessage === true && (
                              <span className="text-red-700 inline-block pt-1 text-sm">
                                Source Type is required
                              </span>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="grid grid-cols-12 gap-6 mt-5 ">
                    <div className="col-span-3 sm:col-span-3">
                      <div className="contentArea">
                        <div>
                          <label className="text-sm text-gray-700">
                            Category Type
                          </label>

                          <Select
                            className="w-full mt-1 text-sm"
                            options={category}
                            theme={(theme) => ({
                              ...theme,
                              colors: {
                                ...theme.colors,
                                primary25: "#B3B3B3",
                                primary: "#041E42",
                              },
                            })}
                            styles={{
                              control: (base, state) => ({
                                ...base,
                                background:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#1A1C23"
                                    : "white",
                                borderColor:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#6B7280"
                                    : "#D1D5DB",
                                borderWidth: "1px",
                                "&:hover": {
                                  borderColor:
                                    state.isFocused &&
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "#6b7280"
                                      : state.isFocused
                                      ? "#4c5563"
                                      : "",
                                },
                              }),
                              singleValue: (base) => ({
                                ...base,
                                color:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "white"
                                    : "#374051",
                              }),
                              input: (base) => ({
                                ...base,
                                color:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "white"
                                    : "",
                              }),
                            }}
                            onChange={handleCategoryChange}
                            value={selectedCategory}
                            isSearchable={true}
                          />
                          {selectedCategory.value === "0" &&
                            errorMessage === true && (
                              <span className="text-red-700 inline-block pt-1 text-sm">
                                Category Type is required
                              </span>
                            )}
                        </div>
                      </div>
                    </div>
                    <div className="col-span-3 sm:col-span-3">
                      <div className="contentArea">
                        <div>
                          <label className="text-sm text-gray-700">
                            Category Old Type
                          </label>
                          <Select
                            className="w-full mt-1 text-sm"
                            options={categoryOld}
                            theme={(theme) => ({
                              ...theme,
                              colors: {
                                ...theme.colors,
                                primary25: "#B3B3B3",
                                primary: "#041E42",
                              },
                            })}
                            styles={{
                              control: (base, state) => ({
                                ...base,
                                background:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#1A1C23"
                                    : "white",
                                borderColor:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#6B7280"
                                    : "#D1D5DB",
                                borderWidth: "1px",
                                "&:hover": {
                                  borderColor:
                                    state.isFocused &&
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "#6b7280"
                                      : state.isFocused
                                      ? "#4c5563"
                                      : "",
                                },
                              }),
                              singleValue: (base) => ({
                                ...base,
                                color:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "white"
                                    : "#374051",
                              }),
                              input: (base) => ({
                                ...base,
                                color:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "white"
                                    : "",
                              }),
                            }}
                            onChange={handleCategoryOldChange}
                            value={selectedCategoryOld}
                            isSearchable={true}
                          />
                          {selectedCategoryOld.value === "0" &&
                            errorMessage === true && (
                              <span className="text-red-700 inline-block pt-1 text-sm">
                                Category Old Type is required
                              </span>
                            )}
                        </div>
                      </div>
                    </div>
                    <div className="col-span-3 sm:col-span-3 ">
                      <div className="contentArea">
                        <div>
                          <label className="text-sm text-gray-700">Grade</label>

                          <Select
                            className="w-full mt-1 text-sm"
                            options={grade}
                            theme={(theme) => ({
                              ...theme,
                              colors: {
                                ...theme.colors,
                                primary25: "#B3B3B3",
                                primary: "#041E42",
                              },
                            })}
                            styles={{
                              control: (base, state) => ({
                                ...base,
                                background:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#1A1C23"
                                    : "white",
                                borderColor:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#6B7280"
                                    : "#D1D5DB",
                                borderWidth: "1px",
                                "&:hover": {
                                  borderColor:
                                    state.isFocused &&
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "#6b7280"
                                      : state.isFocused
                                      ? "#4c5563"
                                      : "",
                                },
                              }),
                              singleValue: (base) => ({
                                ...base,
                                color:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "white"
                                    : "#374051",
                              }),
                              input: (base) => ({
                                ...base,
                                color:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "white"
                                    : "",
                              }),
                            }}
                            onChange={handleGradeChange}
                            value={selectedGrade}
                            isSearchable={true}
                          />
                          {selectedGrade.value === "0" &&
                            errorMessage === true && (
                              <span className="text-red-700 inline-block pt-1 text-sm">
                                Grade is required
                              </span>
                            )}
                        </div>
                      </div>
                    </div>
                    <div className="col-span-3 sm:col-span-3 ">
                      <div className="contentArea">
                        <div>
                          <label className="text-sm text-gray-700">
                            FK Level
                          </label>
                          <input
                            id="flLevel"
                            name="flLevel"
                            type="number"
                            autoComplete="off"
                            placeholder="FK Level"
                            value={flLevel}
                            onChange={flLevelChangeHandler}
                            min={0}
                            className="block w-full mt-1 border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                          />
                          {flLevel === "" && errorMessage === true && (
                            <span className="text-red-700 inline-block pt-1 text-sm">
                              FK Level is required
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
              <div className="grid grid-cols-12 gap-6 mt-5 ">
                <div className="col-span-3 sm:col-span-3 ">
                  <div className="contentArea">
                    <div>
                      <label className="text-sm text-gray-700">
                        Classification
                      </label>

                      <Select
                        className="w-full mt-1 text-sm"
                        options={passageClassification}
                        theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                            primary25: "#B3B3B3",
                            primary: "#041E42",
                          },
                        })}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            background:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "#1A1C23"
                                : "white",
                            borderColor:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "#6B7280"
                                : "#D1D5DB",
                            borderWidth: "1px",
                            "&:hover": {
                              borderColor:
                                state.isFocused &&
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "#6b7280"
                                  : state.isFocused
                                  ? "#4c5563"
                                  : "",
                            },
                          }),
                          singleValue: (base) => ({
                            ...base,
                            color:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "white"
                                : "#374051",
                          }),
                          input: (base) => ({
                            ...base,
                            color:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "white"
                                : "",
                          }),
                        }}
                        onChange={ClassificationChangeHandler}
                        value={selectedClassification}
                        isSearchable={true}
                      />
                    </div>
                  </div>
                </div>
                <div
                  className={`col-span-3 sm:col-span-3 ${
                    selectedPassageType === 2 ? "" : "hidden"
                  }`}
                >
                  <div className="contentArea">
                    <div>
                      <label className="text-sm text-gray-700">
                        Content Area
                      </label>

                      <Select
                        name="contentArea"
                        value={selectedContentArea}
                        options={contentArea}
                        theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                            primary25: "#B3B3B3",
                            primary: "#041E42",
                          },
                        })}
                        onChange={(e) => {
                          handleContenAreaChange(e);
                        }}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            background:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "#1A1C23"
                                : "white",
                            borderColor:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "#6B7280"
                                : "#D1D5DB",
                            borderWidth: "1px",
                            "&:hover": {
                              borderColor:
                                state.isFocused &&
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "#6b7280"
                                  : state.isFocused
                                  ? "#4c5563"
                                  : "",
                            },
                          }),
                          singleValue: (base) => ({
                            ...base,
                            color:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "white"
                                : "#374051",
                          }),
                          input: (base) => ({
                            ...base,
                            color:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "white"
                                : "",
                          }),
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-12 gap-6 mt-5 ">
                {editedPassageId === undefined ? (
                  <div className="col-span-1 md:col-span-3 flex items-end">
                    <div className="flex items-center contentArea">
                      <input
                        id="active"
                        name="isActive"
                        type="checkbox"
                        checked={isActive}
                        onChange={activeChangeHandler}
                        className=" focus:ring-primary-color h-4 w-4 text-primary-color border-gray-300 rounded"
                      />
                      <label className="ml-2 text-sm text-gray-700">
                        Active
                      </label>
                    </div>
                  </div>
                ) : null}

                <div className="col-span-10 md:col-span-5 flex items-center">
                  <div className="flex items-center contentArea pr-3">
                    <input
                      id="isApproved"
                      name="isApproved"
                      type="checkbox"
                      checked={isApproved}
                      onChange={approvedChangeHandler}
                      className=" focus:ring-primary-color h-4 w-4 text-primary-color border-gray-300 rounded"
                    />
                    <label className="ml-2 text-sm text-gray-700">
                      Approved
                    </label>
                  </div>
                  <div className="flex items-center contentArea pr-3">
                    <input
                      id="Disable"
                      name="disablePassageTTS"
                      type="checkbox"
                      checked={disablePassageTTS}
                      onChange={disableChangeHandler}
                      className=" focus:ring-primary-color h-4 w-4 text-primary-color border-gray-300 rounded"
                    />
                    <label className="ml-2 text-sm text-gray-700 whitespace-nowrap">
                      Disable Passage TTS
                    </label>
                  </div>
                  <div className="flex items-center contentArea pr-3">
                    <input
                      id="isMachineTranslated"
                      name="isMachineTranslated"
                      type="checkbox"
                      checked={isMachineTranslated}
                      onChange={() =>
                        setIsMachineTranslated(!isMachineTranslated)
                      }
                      disabled={!isApproved}
                      className=" focus:ring-primary-color h-4 w-4 text-primary-color border-gray-300 rounded"
                    />
                    <label className="ml-2 text-sm text-gray-700">
                      Auto Translate
                    </label>
                  </div>
                  <div className="flex items-center contentArea pr-3">
                    <input
                      id="isAIAssisted"
                      name="isAIAssisted"
                      type="checkbox"
                      checked={isAIAssisted}
                      onChange={() => setIsAIAssisted(!isAIAssisted)}
                      className=" focus:ring-primary-color h-4 w-4 text-primary-color border-gray-300 rounded"
                    />
                    <label className="ml-2 text-sm text-gray-700">
                      AI Assisted
                    </label>
                  </div>
                </div>
                {manageTags && (
                  <div className="col-span-1 md:col-span-6 flex items-end">
                    <div className="flex items-center contentArea">
                      <TagSelector
                        label={"Tags"}
                        onTagSelectChange={(tags) => {
                          handleSaveTags(tags);
                        }}
                        removeTag={handleRemoveTag}
                        mode={TagSelectorMode.Edit}
                        categoryId={0}
                        selectedTagIds={selectedTagIds}
                      />
                    </div>
                  </div>
                )}
              </div>
              <div>{passageEditor}</div>
              <div className="flex justify-end gap-4">
                <button
                  type="button"
                  onClick={passageSubmitHandler}
                  className="inline-flex items-center ml-4 px-3 py-2 my-3 hover:bg-secondary-color border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white dark:text-white bg-primary-color  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color"
                >
                  {editedPassageId !== "" ? " Update " : "Save "}
                </button>

                <Link
                  to="/passages"
                  type="button"
                  className="inline-flex items-center px-3 py-2 my-3 hover:text-gray-500 border border-gray-300 text-sm leading-4 font-medium rounded-md shadow-sm text-gray-700 bg-white  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color"
                >
                  Cancel
                </Link>
              </div>
            </div>
            {manageTags && editedPassageId !== "" && (
              <div>
                <div className=" w-full mt-7 ">
                  <div className="relative  py-1">
                    <div>
                      <h3 className="text-lg font-light text-gray-900">
                        Associated Questions
                      </h3>
                      <button
                        onClick={() => handleRedirect(editedPassageId)}
                        className="inline-flex items-center px-3 py-1 border border-transparent text-sm leading-4 rounded-md shadow-xs text-white dark:text-white bg-primary-color hover:bg-secondary-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color hover:shadow-lg transsition ease-in-out duration-300"
                      >
                        <AddIcon className="w-6"></AddIcon>
                        Add Associate Questions
                      </button>

                      <button
                        onClick={() => UpdatePassageAndRedirectToQuestion()}
                        className="ml-4 inline-flex items-center px-3 py-1 border border-transparent text-sm leading-4 rounded-md shadow-xs text-white dark:text-white bg-primary-color hover:bg-secondary-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color hover:shadow-lg transsition ease-in-out duration-300"
                      >
                        <AddIcon className="w-6"></AddIcon>
                        Add New Question
                      </button>
                    </div>
                    <div className="flex mt-4 items-center justify-end">
                      <div className="flex space-x-4 items-center dark:text-white">
                        <div className="flex items-center ">
                          <PreviewIcon className="mr-2 h-5 w-5 text-xs font-light cursor-pointer text-gray-400 hover:text-secondary-color transaction ease-in-out duration-300" />
                          <div className="pl-2">Preview</div>
                        </div>
                      </div>
                    </div>

                    <div id="dataContainer" className="mt-4">
                      <div className="flex flex-col mt-1">
                        <div className="-my-2 overflow-x-auto px-8 sm:-mx-6 lg:-mx-8">
                          <div className="py-2 align-middle inline-block min-w-full ">
                            <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                              <table className="min-w-full divide-y divide-gray-200">
                                <thead className="bg-primary-color whitespace-nowrap">
                                  <tr>
                                    <th
                                      scope="col"
                                      className=" px-3 py-2 font-light text-sm text-left text-white dark:text-white tracking-wider"
                                    >
                                      Question Id
                                    </th>
                                    <th
                                      scope="col"
                                      className=" px-3 py-2 font-light text-sm text-white dark:text-white tracking-wider"
                                    >
                                      <span>Question</span>
                                    </th>
                                    <th
                                      scope="col"
                                      className="px-3 py-2  justify-center  font-light text-sm  text-white dark:text-white tracking-wider"
                                    >
                                      Diagnostic Question
                                    </th>

                                    <th
                                      scope="col"
                                      className="px-3 w-10 py-2 font-light text-sm text-center text-white dark:text-white tracking-wider"
                                    >
                                      Action
                                    </th>
                                  </tr>
                                </thead>
                                {editedPassageId !== "" && (
                                  <tbody>
                                    {associateQuestion.map(
                                      (question, index) => (
                                        <tr
                                          key={question.questionId}
                                          className={
                                            index % 2 === 0
                                              ? "bg-white"
                                              : "bg-gray-100"
                                          }
                                        >
                                          <td
                                            onClick={() =>
                                              handleEditQuestion(
                                                question?.questionId
                                              )
                                            }
                                            className="cursor-pointer font-medium pl-6 text-indigo-600 hover:text-indigo-500 hover:underline"
                                          >
                                            <div className="flex items-center">
                                              <a
                                                href={constant.MANAGEQUESTION.replace(
                                                  ":id",
                                                  question?.questionId.toString()
                                                )}
                                              >
                                                {question.questionId}
                                              </a>
                                              <UgaItemIcon
                                                externalSourceTypeId={
                                                  question.externalSourceTypeId
                                                }
                                                className="ml-1.5"
                                              />
                                            </div>
                                          </td>
                                          <td
                                            onClick={() =>
                                              handleEditQuestion(
                                                question?.questionId
                                              )
                                            }
                                            className="py-2 pl-6 capitalize  text-sm  font-normal text-gray-500"
                                          >
                                            <Tooltip
                                              text={
                                                question.questionText
                                                  ? question.questionText.replace(
                                                      /<[^>]+>/g,
                                                      ""
                                                    )
                                                  : ""
                                              }
                                            />
                                          </td>
                                          <td className=" py-2  capitalize  flex justify-center  pl-12 font-normal text-gray-500">
                                            {question.isDiagnostics ? (
                                              <CheckIcon className="w-4 text-xs font-light  " />
                                            ) : (
                                              <CrossIcon className="w-4 text-xs font-light" />
                                            )}
                                          </td>

                                          <td className="px-3 py-2  text-sm text-center font-normal text-gray-700">
                                            <div className="flex gap-3 justify-center">
                                              <a
                                                onClick={() =>
                                                  openModal(
                                                    question.englishQuestionReferenceId,
                                                    question.questionId,
                                                    question
                                                  )
                                                }
                                                className="text-gray-900"
                                              >
                                                <PreviewIcon className="mr-3 h-5 w-5 text-xs font-light cursor-pointer text-gray-400 hover:text-secondary-color transaction ease-in-out duration-300" />
                                              </a>
                                              <EditIcon
                                                onClick={() =>
                                                  handleEditQuestion(
                                                    question?.questionId
                                                  )
                                                }
                                                className="w-4 text-xs font-light cursor-pointer hover:text-secondary-color transaction ease-in-out duration-300"
                                              />
                                              <DeleteIcon
                                                onClick={() =>
                                                  deletePassageAssociateQuestion(
                                                    question.questionId,
                                                    question.englishQuestionReferenceId,
                                                    question.spanishQuestionReferenceId
                                                  )
                                                }
                                                className="w-4 text-xs font-light cursor-pointer hover:text-red-500 transaction ease-in-out duration-300"
                                              />
                                            </div>
                                          </td>
                                        </tr>
                                      )
                                    )}
                                  </tbody>
                                )}
                              </table>
                            </div>
                          </div>
                        </div>
                        <div>
                          {associateQuestion.length === 0 ? (
                            <p className="p-2">No Records Found</p>
                          ) : null}
                        </div>
                      </div>
                      <div
                        className={`flex justify-between items-center ${
                          associateQuestion.length === 0 ? "hidden" : ""
                        }`}
                      >
                        <Pagination
                          pages={totalPages}
                          setPageNumber={setPageNumber}
                          ref={paginationRef}
                        />
                        <span>
                          <span className="text-sm pr-4 ml-auto text-left-700">
                            Showing {pageNumber} to{" "}
                            {totalRecords < pageSize ? totalRecords : pageSize}{" "}
                            of {totalRecords} results
                          </span>

                          <SelectPageSize
                            setPageSize={setPageSize}
                            type={"second"}
                            ref={pageSizeRef}
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {showPassageTypeModal && (
        <div>
          <Transition.Root show={true} as={Fragment}>
            <Dialog
              as="div"
              className="fixed z-10 inset-0"
              onClose={() => navigate("/subjects")}
            >
              <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                <TransitionChild
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <DialogBackdrop className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </TransitionChild>

                {/* This element is to trick the browser into centering the modal contents. */}
                <span
                  className="hidden sm:inline-block sm:align-middle sm:h-screen"
                  aria-hidden="true"
                >
                  &#8203;
                </span>
                <TransitionChild
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left  shadow-xl transform transition-all sm:my-8 sm:align-middle sm:p-6 w-1/4">
                    <form>
                      <div className="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
                        <button
                          type="button"
                          className="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none "
                          onClick={() => navigate("/passages")}
                        >
                          <span className="sr-only">Close</span>
                          <XIcon className="h-6 w-6" aria-hidden="true" />
                        </button>
                      </div>
                      <div className="sm:flex sm:items-start">
                        <div className="w-full mt-3 text-center sm:mt-0 sm:text-left">
                          <DialogTitle
                            as="h3"
                            className="text-sm text-gray-700"
                          >
                            Passage Type
                          </DialogTitle>

                          <div className="grid grid-cols-1 divide-y divide-gray-300 border border-gray-300 rounded-lg ">
                            <div className=" bg-gray-100 h-22 px-4 py-4 flex">
                              <div className="flex items-center w-full">
                                <input
                                  id="radio1"
                                  type="radio"
                                  className=" h-4 w-4 "
                                  onClick={() =>
                                    onPassageTypeChange(
                                      constant.PASSAGETYPE.READING
                                    )
                                  }
                                  checked={
                                    selectedPassageType ===
                                    constant.PASSAGETYPE.READING
                                  }
                                />
                                <label className="focus:ring-primary-color dark:text-white text-primary-color border-gray-300 ml-2">
                                  Reading Passage
                                </label>
                              </div>
                            </div>
                            <div className=" h-22 px-4 py-4 flex w-full">
                              <div className="flex items-center w-full">
                                <input
                                  id="radio2"
                                  type="radio"
                                  className=" h-4 w-4 "
                                  onClick={() =>
                                    onPassageTypeChange(
                                      constant.PASSAGETYPE.NONREADING
                                    )
                                  }
                                  checked={
                                    selectedPassageType ===
                                    constant.PASSAGETYPE.NONREADING
                                  }
                                />
                                <label className="focus:ring-primary-color dark:text-white text-primary-color border-gray-300 ml-2">
                                  Non Reading Passage
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </TransitionChild>
              </div>
            </Dialog>
          </Transition.Root>
        </div>
      )}
    </AllowedTo>
  );
};
const mapStateToProps = (state: any) => {
  return {
    profile: state.profile,
  };
};
export default connect(mapStateToProps, {})(ManagePassage);
